import React, { Component } from 'react';
import { ViewModes } from '../../components/tab-action-bar';
import { DyzioStorage } from '../has-localstorage-client';

class ViewModeManager {
  getViewMode = argument => {
    if (!argument || !argument.value) {
      return ViewModes.cardsLarge;
    }
    return argument.value;
  }

  updateViewMode = (key, viewMode) => {
    const storage = new DyzioStorage();
    const record = storage.get(key);
    record.value = viewMode;
    storage.set(key, record);
  }
}

const hasViewModeManagement = WrapperComponent => class HasViewModeManagement extends Component {
  render() {
    return <WrapperComponent {...this.props} viewModeManager={new ViewModeManager()} />;
  }
};

export default hasViewModeManagement;



/** WEBPACK FOOTER **
 ** ./src/hocs/has-viewmode-management/index.js
 **/